import { AsYouType, type CountryCode } from "libphonenumber-js";

export const useFormatPhone = () => {
  const formatPhone = (
    value: string | undefined | null,
    countryCode: CountryCode = "KH",
  ) => {
    if (!value) return "";

    const digitsOnly = value.replace(/\D/g, "");
    let formattedValue = "";

    if (digitsOnly.length > 0) {
      if (countryCode === "KH" && !digitsOnly.startsWith("0")) {
        const intlFormatter = new AsYouType();
        const fullFormat = intlFormatter.input("+855" + digitsOnly);
        formattedValue = fullFormat.replace(/^\+855\s?/, "");
      } else {
        formattedValue = new AsYouType(countryCode).input(digitsOnly);
      }
    }

    return formattedValue;
  };

  return { formatPhone };
};
